const doc = [({"zh_tw":({"adminConstantBookingStatus":({"arranged":"已預約", "cancelled":"已取消", "modified":"已經改變了", "requested":"請求"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;